"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gql = void 0;
/**
 * Custom GQL template literal tag for syntax highlighting and auto-complete of GQL operations in IDEs.
 */
const gql = exports.gql = String.raw;
